module.exports = __webpack_public_path__ + "img/w3_cart_dark.127949c9.png";